import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useTranslation } from "../context/TranslationContext";
import { ReactComponent as PanelAlerts } from '../resources/assets/panelAlerts.svg';
import { ReactComponent as PanelMessages } from '../resources/assets/panelMessages.svg';
import { ReactComponent as PanelHost } from '../resources/assets/panelHost.svg';
import { ReactComponent as PanelTasks } from '../resources/assets/panelTasks.svg';
import { ReactComponent as PanelProfile } from '../resources/assets/panelProfile.svg';
import PanelIcon from '../components/PanelIcon';
import '../styles/BottomPanel.css';

const BottomPanel = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const path = location.pathname;

    const hidePanel = false;

    if(path === '/login')   hidePanel   = true;
    
    return (
        <div>
        <div style={{ paddingBottom: hidePanel ? '0' : '60px' }}>
            <Outlet />
        </div>

        {!hidePanel && (
            <div className="bottom-panel">
                <PanelIcon to="/profile" label={t.bottomPanel.Profile} Icon={PanelProfile}/>
                <PanelIcon to="/tasks" label={t.bottomPanel.Tasks} Icon={PanelTasks}/>
                <PanelIcon to="/host" label={t.bottomPanel.Host} Icon={PanelHost}/>
                <PanelIcon to="/messages" label={t.bottomPanel.Messages} Icon={PanelMessages}/>
                <PanelIcon to="/alerts" label={t.bottomPanel.Alerts} Icon={PanelAlerts}/>
            </div>
        )}
        </div>
    );
};

export default BottomPanel;